import './styles/Truncate.scss';

import {
  Fragment,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';

import { useClassHelper } from '../../hooks';
import { Maybe } from '../../types';
import { Stack } from '../Stack';
import { Paragraph } from '../Typography';

const componentName = 'c-TruncateText';

interface Props extends PropsWithChildren {
  showMoreButton?: boolean;
  showLessButton?: boolean;
}

export const TruncateText = ({
  children,
  showMoreButton = false,
  showLessButton = false,
}: Props) => {
  const containerRef = useRef<Maybe<any>>(null);
  const c = useClassHelper(componentName);

  const [isTruncated, setIsTruncated] = useState(true);
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (containerRef.current) {
        const container = containerRef.current;

        const show = container.scrollWidth > container.offsetWidth;

        if (showMoreButton || showLessButton) {
          setShowButtons(show);
        }
      }
    };

    checkTruncation();
  }, []);

  return (
    <Fragment>
      <Stack direction="row" className={`${c('__container')} gap-[5px]!`}>
        <Paragraph
          className={c({
            '__url--truncated': isTruncated,
            '__url--expanded': !isTruncated,
          })}
          ref={containerRef}
        >
          {children}{' '}
          {showButtons && (
            <Fragment>
              {!isTruncated && (
                <Paragraph
                  role="button"
                  tag="span"
                  size="sm"
                  onClick={() => setIsTruncated(prev => !prev)}
                  className={c('__button')}
                >
                  Show less
                </Paragraph>
              )}
            </Fragment>
          )}
        </Paragraph>
        {showButtons && (
          <Fragment>
            {isTruncated && (
              <Paragraph
                role="button"
                tag="span"
                size="sm"
                onClick={() => setIsTruncated(prev => !prev)}
                className={c('__button')}
              >
                Show More
              </Paragraph>
            )}
          </Fragment>
        )}
      </Stack>
    </Fragment>
  );
};
